import * as React from "react";
export class MiniPlaceholder extends React.PureComponent {
    renderItems(eventsCount) {
        let elements = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: `mini-placeholder_item_${i}`, className: "rj-mini-ev-card__placeholder__card-items-wrap" },
                React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-info" },
                    React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-names-wrap" },
                        React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-name" }),
                        React.createElement("div", { className: "rj-mini-ev-card__placeholder__player-name" })),
                    React.createElement("div", { className: "rj-mini-ev-card__placeholder__card-item-icon" }))));
        }
        return elements;
    }
    render() {
        return (React.createElement("div", { className: "rj-mini-ev-card__placeholder" }, this.renderItems(this.props.eventsCount)));
    }
}
//# sourceMappingURL=MiniPlacehoder.js.map